// TODO(somewhatabstract, MP-3016): Update this page to use Wonder Blocks
// typography and better layout tools so that we don't need these custom less
// files.
import "../../stylesheets/grids-package/grids.less";
import "../../stylesheets/mobile-package/mobile.less";
import "../../stylesheets/donate-package/donate.less";

import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";
import * as React from "react";

import Button from "@khanacademy/wonder-blocks-button";
import {doNotTranslate} from "@khan/i18n";
import {Errors, KAError} from "@khan/logging";
import {executeExternalScript} from "@khan/util-external-script";

import AboutHeader from "#about-appshell/about-header.tsx";
import AboutNav from "#about-appshell/about-nav.tsx";
import PageRoot from "#app-shell-package/page-root.tsx";
import Social from "#shared-package/social.ts";

import {withStrings} from "./locales/donate-match-page/load-strings.tsx";

import twitterIcon from "@phosphor-icons/core/regular/twitter-logo.svg";

type DonateMatchContentProps = {
    onClick: (itemKey: string) => unknown;
};
type DonateMatchPageProps = Record<any, any>;

function DonateMatchContent({onClick}: DonateMatchContentProps) {
    executeExternalScript(
        "https://matchbox.hepdata.com/edl/khanacademy_iframe/dtfqiden/script.js",
    );

    return (
        <div className="container contribute-container">
            <div className="row-fluid match">
                <div className="callout">
                    <h1>{t`Let your company double your impact!`}</h1>
                    <p>
                        {t`Many companies have a matching gift program — you give an amount and they donate the same. Both donations go straight to Khan Academy.`}
                    </p>
                </div>
                <hr />
                <div className="span4">
                    <div>
                        <h4>{t`Donate`}</h4>
                        <p>
                            {t`If you’re seeing this page, chances are you've already done this step! Thank you so much! If not, please make a donation and be sure to keep your receipt.`}{" "}
                        </p>
                        <p>
                            {" "}
                            {t`Many corporate matching programs will give you up to one year after your donation to request a match.`}
                        </p>

                        <h4>{t`Match`}</h4>
                        <p>
                            {t`Search for your company using the form on the right. Even if nothing comes up, your company may still have a matching program. You can contact your HR department to find out.`}
                        </p>

                        <p>
                            {t`There are two ways to submit the matching request:`}
                        </p>
                        <ul>
                            <li>
                                <p>
                                    {t`Download your company's matching gift verification form using the provided link. Print it, fill it out and mail it to us:`}
                                </p>
                                <p>
                                    {doNotTranslate`P.O. Box 1630`}
                                    <br />
                                    {doNotTranslate`Mountain View, CA 94042`}
                                    <br />
                                </p>
                            </li>
                            <li>
                                <p>
                                    {t`Submit a request to your company’s intranet if you find a link to that in the search results.`}
                                </p>
                            </li>
                        </ul>
                        <p>
                            <Trans>
                                Questions? Email{" "}
                                <a href="mailto:donate@khanacademy.org">
                                    donate@khanacademy.org
                                </a>
                                . Oh, and thanks!
                            </Trans>
                        </p>
                        <h4>{t`Spread the word`}</h4>
                        <p>
                            {t`It takes a vibrant community to deliver a free, world-class education for anyone, anywhere.  Tell your friends and family that their gifts to Khan Academy can be matched and inspire them to give, too.`}
                        </p>
                        <Button
                            onClick={() => onClick("twitter")}
                            startIcon={twitterIcon}
                        >
                            {t`Tweet`}
                        </Button>
                    </div>
                </div>
                <div className="embedded-match span6">
                    <div className="search last">
                        {/* This is used by the https://matchbox.hepdata.com
                        to render the employer search form. Do not remove. */}
                        <div id="edl-template" />
                    </div>
                </div>
            </div>
        </div>
    );
}

/**
 * Handles clicks for our social media links.
 */
const onClickHandler = (itemKey: string): void => {
    switch (itemKey) {
        case "twitter":
            Social.openTwitterPopup(
                Social.formatTwitterShareUrl({
                    url: "www.khanacademy.org",
                    text: t`I just donated to @KhanAcademy. Join me in supporting a free, world-class education for anyone, anywhere! khanacademy.org/donate`,
                }),
            );
            break;

        /**
         * TODO(joshuan): Reinstate Facebook button with correct branding.
         *
         * case "facebook": ...
         */

        default:
            // Uh oh, what is this
            // Probably dev work adding a new button. Let's give them some
            // feedback.
            throw new KAError(
                `Unsupported item key: ${itemKey}`,
                Errors.Internal,
            );
    }
};

/**
 * Render the /donate/match page on corporate donation matching.
 */
export default withStrings(
    (props: DonateMatchPageProps): React.ReactElement => (
        <PageRoot settings={{title: t`Matching Gifts`}}>
            <div className="about-page">
                <AboutHeader pageheadline={t`Matching Gifts`} />
                <AboutNav />
                <DonateMatchContent onClick={onClickHandler} />
            </div>
        </PageRoot>
    ),
);
